import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function Error({ error }: Props) {
  const { t } = useTranslation();
  const hasError =
    error.doesNotHaveNumberOrSpecialChar ||
    error.doesNotHaveUpper ||
    error.isTooShort ||
    error.mismatchedConfirmation;

  return hasError ? (
    <ul className={styles.error}>
      {error.wrongPassword && (
        <li>
          <p className={styles.text}>
            {t("preferences.changePassword.errors.wrongPassword")}
          </p>
        </li>
      )}
      {error.isTooShort && (
        <li>
          <p className={styles.text}>
            {t("preferences.changePassword.errors.tooShort")}
          </p>
        </li>
      )}
      {error.mismatchedConfirmation && (
        <li>
          <p className={styles.text}>
            {t("preferences.changePassword.errors.mismatchedConfirmation")}
          </p>
        </li>
      )}
      {error.doesNotHaveUpper && (
        <li>
          <p className={styles.text}>
            {t("preferences.changePassword.errors.upper")}
          </p>
        </li>
      )}
      {error.doesNotHaveNumberOrSpecialChar && (
        <li>
          <p className={styles.text}>
            {t("preferences.changePassword.errors.specialCharsOrNum")}
          </p>
        </li>
      )}
    </ul>
  ) : (
    <React.Fragment />
  );
}

export { Error };
